// Libs
import classNames from 'classnames/bind';
import { Box, Drawer } from '@mui/material';
import { ReactNode } from 'react';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './BaseDrawer.module.scss';
import { useTranslation } from 'react-i18next';
import { icons } from '~/assets';

type Props = {
  id?: string;
  isOpen: boolean;
  children: ReactNode;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const BaseDrawer = (props: Props) => {
  //#region Destructuring Props
  const { id, isOpen, children, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Drawer id={id} anchor='right' open={isOpen} onClose={onClose} className={cx('drawerContainer')}>
      <Box component={'div'} className={cx('drawerArrowClose')} onClick={onClose}>
        <img
          src={icons.drawerIconArrowClose}
          alt={t('common_alt_img')}
          className={cx('drawerArrowCloseImg')}
        />
      </Box>

      <Box component={'div'} className={cx('drawerClose')} onClick={onClose}>
        <img src={icons.commonIconClose} alt={t('common_alt_img')} className={cx('drawerCloseImg')} />
      </Box>

      <Box component={'div'} className={cx('drawerContent')}>
        {children}
      </Box>
    </Drawer>
  );
};

export default BaseDrawer;
